document.addEventListener("DOMContentLoaded", () => {
  const INSURANCE_VARIANT_IDS = {
    500: "51300940677301",
    1000: "51300940710069",
    1500: "51300940742837",
    2000: "51300940775605",
    2500: "51300940808373",
    3000: "51300940841141",
    3500: "51300940873909",
    4000: "51300940906677",
    4500: "51300940939445",
    5000: "51300940972213",
    5500: "51300941004981",
    6000: "51300941037749",
    6500: "51300941070517",
    7000: "51300941103285",
    7500: "51300941136053",
    8000: "51300941168821",
    8500: "51300941201589",
    9000: "51300941234357",
    9500: "51300941267125",
    10000: "51300941299893",
  };

  const currencyCode = window.Shopify?.currency?.active || 'USD';
  const currencyRate = window.Shopify?.currency?.rate || 1;

  const getCart = () => fetch("/cart.js").then((res) => res.json());

  const determineVariantId = (total_price) => {
    const price = total_price / 100 / currencyRate; // 转为 USD 基准
    const tiers = Object.keys(INSURANCE_VARIANT_IDS)
      .map(Number)
      .sort((a, b) => a - b);
    for (let i = 0; i < tiers.length; i++) {
      if (price <= tiers[i]) return INSURANCE_VARIANT_IDS[tiers[i]];
    }
    return null;
  };

  const removeAllInsuranceVariants = async (cart) => {
    const variantIds = Object.values(INSURANCE_VARIANT_IDS);
    const removals = cart.items
      .filter((item) => variantIds.includes(item.variant_id.toString()))
      .map((item) =>
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        })
      );
    await Promise.all(removals);
  };

  const updateInsuranceLabel = (price) => {
    const labelEl = document.querySelector(
      'label[for="add-insurance-checkbox"] strong'
    );
    if (labelEl) {
      const estimatedFee = price * 0.02;

      const formatted = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
      }).format(estimatedFee);

      labelEl.textContent = `Add Shipping Insurance (2%) ≈ ${formatted}`;
    }
  };

  let isProcessing = false;
  const setupCheckbox = async () => {
    const checkbox = document.getElementById("add-insurance-checkbox");
    if (!checkbox || isProcessing) return;

    checkbox.disabled = true;

    try {
      const cart = await getCart();
      const currentId = determineVariantId(cart.total_price);
      const variantIds = Object.values(INSURANCE_VARIANT_IDS);
      const matchedItem = cart.items.find((item) =>
        variantIds.includes(item.variant_id.toString())
      );

      checkbox.checked = matchedItem?.variant_id.toString() === currentId;
      updateInsuranceLabel(cart.total_price / 100);

      if (!checkbox.hasSetup) {
        checkbox.addEventListener("change", async () => {
          if (isProcessing) return;
          isProcessing = true;
          checkbox.disabled = true;

          try {
            const updatedCart = await getCart();
            const newVariantId = determineVariantId(updatedCart.total_price);
            await removeAllInsuranceVariants(updatedCart);

            if (checkbox.checked && newVariantId) {
              const res = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: newVariantId, quantity: 1 }),
              });

              if (!res.ok) throw new Error("Add insurance failed");
            }

            document.dispatchEvent(
              new CustomEvent("cart:refresh", { detail: { open: true } })
            );
          } catch (err) {
            console.error("Insurance update error:", err);
            checkbox.checked = false;
          } finally {
            checkbox.disabled = false;
            isProcessing = false;
          }
        });
        checkbox.hasSetup = true;
      }

      checkbox.disabled = false;
    } catch (err) {
      console.error("Cart load error:", err);
      checkbox.disabled = false;
    }
  };

  const throttle = (fn, delay) => {
    let timer;
    return (...args) => {
      if (!timer) {
        timer = setTimeout(() => {
          fn(...args);
          timer = null;
        }, delay);
      }
    };
  };

  const observer = new MutationObserver(throttle(setupCheckbox, 300));
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener("cart:updated", () => {
    setupCheckbox();
  });

  setupCheckbox();
});